module.exports = __webpack_public_path__ + "static/media/photo109.2b05f116.jpg";